import Vue from "vue";
import Router from "vue-router";
import store from "@/store";
import {GetRequest} from "@/utils/utils.js";

Vue.use(Router);

const router = new Router({
    routes: [
        {
            path: "/",
            redirect: "/tabbar/user", //重定向
        },
        {
            path: "/login",
            name: "login",
            meta: {
                title: "登录",
                index: 0,
                keep_alive: true,
            },
            component: () => import("@/views/login.vue"),
        },
        {
            path: "/auth",
            name: "auth",
            meta: {
                title: "微信登录",
                index: 0,
            },
            component: () => import("@/views/auth/wx_auth.vue"),
        },
        {
            path: "/system",
            name: "system",
            component: () => import("@/views/system/layout.vue"),
            redirect: "/system/chg-pass",
            children: [
                {
                    path: "chg-pass",
                    name: "chgPass",
                    meta: {
                        title: "修改密码",
                        index: 0,
                        keep_alive: true,
                        isCanReturn: true,
                    },
                    component: () => import("@/views/system/chg-pass.vue"),
                }
            ]
        },
        {
            path: "/tabbar",
            name: "tabbar",
            component: () => import("@/views/tabbar.vue"),
            children: [
                {
                    path: "labs",
                    name: "labs",
                    meta: {
                        title: "请选择送检实验室", //商城
                        index: 0,
                        keep_alive: true,
                        isCanReturn: true,
                    },
                    component: () => import("@/views/tab/labs.vue"),
                },
                {
                    path: "getOrder",
                    name: "getOrder",
                    meta: {
                        title: "我要下单", //商城
                        index: 0,
                        keep_alive: true,
                        isCanReturn: true,
                    },
                    component: () => import("@/views/tab/getOrder.vue"),
                },
                {
                    path: "examine",
                    name: "examine",
                    meta: {
                        title: "审核",
                        index: 0,
                        keep_alive: true,
                        isCanReturn: true,
                    },
                    component: () => import("@/views/tab/examine.vue"),
                },
                {
                    path: "user",
                    name: "user",
                    meta: {
                        title: "个人中心",
                        index: 0,
                        keep_alive: true,
                    },
                    component: () => import("@/views/tab/user.vue"),
                },
            ],
        },
        {
            path: "/lab",
            name: "lab",
            component: () => import("@/views/lab/index.vue"),
            children: [
                {
                    path: "lab-order",
                    name: "lab-order",
                    meta: {
                        title: "检验订单",
                        index: 0,
                        keep_alive: true,
                        isCanReturn: true,
                    },
                    component: () => import("@/views/lab/order.vue"),
                }
            ],
        },
        {
            path: "/bill",
            name: "bill",
            meta: {
                title: "月度帐单",
                index: 2,
                keep_alive: true,
            },
            component: () => import("@/views/bill/month-bill.vue"),
        },
        {
            path: "/balance-detail",
            name: "balanceDetail",
            meta: {
                title: "余额明细",
                index: 2,
                keep_alive: true,
            },
            component: () => import("@/views/balance/list.vue"),
        },
        {
            path: "/balance",
            name: "balance",
            meta: {
                title: "我的余额",
                index: 2,
                keep_alive: true,
            },
            component: () => import("@/views/balance/index.vue"),
        },
        {
            path: "/item",
            name: "item",
            meta: {
                title: "项目详情",
                index: 2,
                keep_alive: true,
            },
            component: () => import("@/views/item/detail.vue")
        },
        {
            path: "/editCode",
            name: "editCode",
            meta: {
                title: "录入条码",
                index: 4,
                keep_alive: true,
            },
            component: () => import("@/views/editCode.vue"),
        },
        {
            path: "/editInfo",
            name: "editInfo",
            meta: {
                title: "录入信息",
                index: 5,
                keep_alive: true,
            },
            component: () => import("@/views/editInfo.vue"),
        },
        {
            path: "/checkOrderInfo",
            name: "checkOrderInfo",
            meta: {
                title: "预览信息",
                index: 6,
                keep_alive: true,
            },
            component: () => import("@/views/checkOrderInfo.vue"),
        },
        {
            path: "/pay",
            name: "pay",
            meta: {
                title: "支付",
                index: 7,
                keep_alive: true,
            },
            component: () => import("@/views/pay.vue"),
        },
        {
            path: "/clinicList",
            name: "clinicList",
            meta: {
                title: "我的客户",
                index: 1,
                keep_alive: true,
            },
            component: () => import("@/views/clinicList.vue"),
        },
        {
            path: '/order',
            name: 'order',
            meta: {
                title: '全部订单',
                index: 1,
                keep_alive: true
            },
            component: () => import('@/views/order.vue')
        },
        {
            path: '/plus-orders',
            name: 'order',
            meta: {
                title: '加做订单',
                index: 1,
                keep_alive: true
            },
            component: () => import('@/views/plusOrders.vue')
        },
        {
            path: "/orderDetail",
            name: "orderDetail",
            meta: {
                title: "订单详情",
                index: 2,
            },
            component: () => import("@/views/orderDetail.vue"),
        },
        {
            path: "/reportList",
            name: "reportList",
            meta: {
                title: "报告详情",
                index: 2,
            },
            component: () => import("@/views/report.vue"),
        },
        {
            path: "/authorize",
            name: "authorize",
            meta: {
                title: "微信登录",
                index: 0,
            },
            component: () => import("@/views/authorize.vue"),
        },
        {
            path: "/EinvoiceDetail",
            name: "EinvoiceDetail",
            meta: {
                title: "查看报告",
                index: 4,
            },
            component: () => import("@/views/EinvoiceDetail.vue"),
        },
        {
            path: "/salesOrderList",
            name: "salesOrderList",
            meta: {
                title: "审核列表",
                index: 2,
                // keep_alive: true,
            },
            component: () => import("@/views/salesOrderList.vue"),
        },{
            path: "/salesOrderDetail",
            name: "salesOrderDetail",
            meta: {
                title: "订单详情",
                index: 3,
                keep_alive: true,
            },
            component: () => import("@/views/salesOrderDetail.vue"),
        }
    ],
    scrollBehavior(to, from, savedPosition) {
        if (to.meta.isScroll) {
            return {x: 0, y: 0};
        }
    },
});

router.beforeEach(async (to, from, next) => {
    if (to.path !== '/reportList' && store.getters.noToken) {
        //读取缓存信息
        let loginInfo = JSON.parse(localStorage.getItem("loginInfo"));
        if (loginInfo && loginInfo.token && loginInfo.roleType) {
            localStorage.setItem("loginInfo", JSON.stringify(loginInfo));
            //存储登录信息
            store.dispatch("saveToken", {
                ...loginInfo,
            });
            if(!loginInfo.wechatAuth){
                if(to.path!=='/auth'){
                    next('/auth')
                    return
                }
            }
            if(to.path === '/login' || to.path === '/auth'){
                next('/tabbar/user')
                return
            }
        } else {
            if(to.path !== '/login'){
                next('/login')
                return
            }
        }
    } else {
        if (to.path !== '/reportList') {
            let loginInfo = JSON.parse(localStorage.getItem("loginInfo"));
            if(!loginInfo.wechatAuth){
                if(to.path!=='/auth'){
                    next('/auth')
                    return
                }
            }
        }
    }
    if (to.meta.title) {
        document.title = to.meta.title;
    }
    next();
});

//http,某些网络下手机加载js资源失败
router.onError((error) => {
    console.log(error)
    //需要replace的路由
    const replace_list = ["PayMethod", "PaySuccess", "ApplyforReturn"];
    const pattern = /chunk-/g;
    const isChunkLoadFailed = error.request.match(pattern);
    const targetPath = router.history.pending.fullPath;
    if (error.type === "missing" && isChunkLoadFailed) {
        replace_list.includes(router.history.pending.name)
            ? router.replace(targetPath)
            : router.push(targetPath);
    }
});
export default router;
